import axios from "axios";

const axiosHttp = axios.create({
    responseType: "json",
    baseURL: process.env.REACT_APP_ENDPOINT,
});

export default function fetchData(url: string, params: any = {}, method: string = 'GET') {

    params['__url__'] = window.location.pathname

    switch (method) {
        case 'DELETE':
            return axiosHttp.delete(url, params).then(response => response.data);
        case 'PUT':
            return axiosHttp.put(url, params).then(response => response.data);
        case 'POST':
            return axiosHttp.post(url, params).then(response => response.data);
        case 'GET':
            return axiosHttp.get(url, params).then(response => response.data);
        default:
            return axiosHttp.post(url, params).then(response => response.data);
    }
}